import React from 'react';
import moment from 'moment';

const StatusBadgeClass = {
    PENDING: 'badge-secondary',
    QUEUED: 'badge-warning',
    SENDING: 'badge-primary',
    SENT: 'badge-info',
    DELIVERED: 'badge-success',
    BOUNCED: 'badge-danger',
    COMPLAINT: 'badge-danger',
    REJECTED: 'badge-danger',
    FAILED: 'badge-danger',
}

const CampaignRecipientTable = (props) => {
    const {recipients, selectable, selectedIds = [], onToggle, onToggleAll} = props

    // recipient chỉ retry được khi có candidate_id (DraftPreview cần candidate)
    const selectableRecipients = (recipients || []).filter(r => r.candidate_id)
    const allSelectableSelected = selectableRecipients.length > 0
        && selectableRecipients.every(r => selectedIds.includes(r.id))

    return (
        <table
            className='table table-bordered table-hover dataTable dtr-inline text-nowrap text-center'
        >
            <thead>
            <tr>
                {selectable &&
                    <th className={"pl-0"}>
                        <input type="checkbox"
                            style={{width: 20, height: 20}}
                            checked={allSelectableSelected}
                            disabled={selectableRecipients.length === 0}
                            onChange={() => onToggleAll && onToggleAll()}
                        />
                    </th>
                }
                <th>No.</th>
                <th>Email</th>
                <th>Trạng thái</th>
                <th>Ngày giờ gửi</th>
                <th>Notes</th>
            </tr>
            </thead>
            <tbody>
            {recipients && recipients.length > 0 && recipients.map((recipient, index) => (
                <tr key={`recipient_${recipient.id}`}>
                    {selectable &&
                        <td style={{paddingLeft: '.75rem'}}>
                            <input type="checkbox"
                                style={{width: 20, height: 20}}
                                checked={selectedIds.includes(recipient.id)}
                                disabled={!recipient.candidate_id}
                                onChange={() => onToggle && onToggle(recipient)}
                            />
                        </td>
                    }
                    <td>{index + 1}</td>
                    <td className={"text-truncate"}>{recipient.email}</td>
                    <td className={"text-truncate"}>
                        <span className={`badge badge-pill ${StatusBadgeClass[recipient.status] || 'badge-secondary'}`}>
                            {recipient.status}
                        </span>
                    </td>
                    <td className={"text-truncate"}>
                        {recipient.sent_at ? moment(recipient.sent_at).format('YYYY-MM-DD HH:mm') : '-'}
                    </td>
                    <td style={{whiteSpace: 'normal', wordBreak: 'break-word', maxWidth: '400px'}}>
                        {recipient.error_message || '-'}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    );
};

export default CampaignRecipientTable;
